export const itemvalueConfig = [
  {
    name: 'sentiment',
    type: 'sentiment',
    isRequired: false,
    category: 'general',
    visibleIndex: 3,
  },
];
